import CTASection from '../components/CTASection/CTASection';
import ShowcaseMockups from '../components/ShowcaseMockups/ShowcaseMockups';
import { technologyPillars } from '../data/technology';
import { stockAssets } from '../config/stockAssets';
import { usePageTitle } from '../hooks/usePageTitle';
import styles from './TechnologyPage.module.css';

const integrations = [
  {
    icon: '🧾',
    title: 'POS systems',
    description: 'ONI complements your existing point-of-sale so orders flow into the tools your teams already use.',
  },
  {
    icon: '💳',
    title: 'Payment processors',
    description: 'Stripe by default, with the flexibility to integrate your preferred processor on a venue-by-venue basis.',
  },
  {
    icon: '📶',
    title: 'Venue Wi-Fi',
    description: 'Built to perform on stadium networks so fans can order reliably even in a packed house.',
  },
];

function TechnologyPage() {
  usePageTitle('Technology');

  return (
    <>
      <section className={styles.hero}>
        <div className={`container ${styles.heroGrid}`}>
          <div>
            <span className="sectionLabel">Technology</span>
            <h1 className={styles.title}>The platform behind every order</h1>
            <p className={styles.lead}>
              ONI connects the fan ordering experience with the tools stadium teams use to fulfill, track, and optimize
              every order — built on modern infrastructure designed for live-event scale.
            </p>
          </div>
          <img
            src={stockAssets.technologyKitchen}
            alt="Stadium kitchen staff preparing an ONI order beside a live order-tracking screen"
            className={styles.heroImage}
            loading="eager"
          />
        </div>
      </section>

      <ShowcaseMockups showLearnMore={false} />

      <section className={`section ${styles.pillars}`}>
        <div className="container">
          <span className="sectionLabel">Platform pillars</span>
          <h2 className="sectionTitle">Built for stadium operations at scale</h2>
          <p className="sectionSubtitle">
            Five core capabilities that power in-seat ordering from fan checkout to venue analytics.
          </p>

          <div className={styles.pillarGrid}>
            {technologyPillars.map((pillar) => (
              <article key={pillar.title} className={styles.pillarCard}>
                <span className={styles.icon} aria-hidden="true">{pillar.icon}</span>
                <h3 className={styles.pillarTitle}>{pillar.title}</h3>
                <p className={styles.pillarDescription}>{pillar.description}</p>
                <ul className={styles.points}>
                  {pillar.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className={`section ${styles.integrations}`}>
        <div className="container">
          <span className="sectionLabel">Integrations</span>
          <h2 className="sectionTitle">Integrates with your existing operations</h2>
          <p className="sectionSubtitle">
            ONI fits into the systems your venue already runs — no rip-and-replace required.
          </p>

          <div className={styles.integrationGrid}>
            {integrations.map((integration) => (
              <article key={integration.title} className={styles.integrationCard}>
                <span className={styles.icon} aria-hidden="true">{integration.icon}</span>
                <h3 className={styles.pillarTitle}>{integration.title}</h3>
                <p className={styles.pillarDescription}>{integration.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}

export default TechnologyPage;
